/**
 * Generated by orval v7.13.0 🍺
 * Do not edit manually.
 * 救急隊ポータルApp
 * OpenAPI spec version: 0.1.0
 */

/**
 * 搬送体位
 */
export type RequestSummaryTransportBodyPositionEnum =
  (typeof RequestSummaryTransportBodyPositionEnum)[keyof typeof RequestSummaryTransportBodyPositionEnum];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const RequestSummaryTransportBodyPositionEnum = {
  SUPINE: 'SUPINE',
  LATERAL: 'LATERAL',
  SITTING: 'SITTING',
  SEMI_SITTING: 'SEMI_SITTING',
  PRONE: 'PRONE',
  KNEE_FLEXION: 'KNEE_FLEXION',
  SHOCK: 'SHOCK',
  STANDING: 'STANDING',
  OTHER: 'OTHER',
} as const;
